import { render, staticRenderFns } from "./ControlPanelUsers.vue?vue&type=template&id=63f4025e&"
import script from "./ControlPanelUsers.vue?vue&type=script&lang=js&"
export * from "./ControlPanelUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports